<div class="configuration-banner" *ngIf="!environment.production" [ngStyle]="{ 'background-color': '#'+getEnvironmentColor() }"> {{ environment.configuration }} </div>
<router-outlet></router-outlet>